import { createFileRoute } from '@tanstack/react-router';
import DemosListPage from '../../../../../app/demos/DemosListPage';
import { buildHead } from '../../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/agent/demos/')({
  component: DemosListPage,
  head: () => buildHead('/products/agent/demos'),
});
